import React from 'react';
import { Outlet } from 'react-router-dom';
import { Header } from './Header';
import { Footer } from './Footer';
export function Layout() {
  return <div className="flex min-h-screen flex-col" data-id="element-105">
      <Header data-id="element-106" />
      <main className="flex-1" data-id="element-107">
        <Outlet data-id="element-108" />
      </main>
      <Footer data-id="element-109" />
    </div>;
}